import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Menu,
  MenuItem,
  Fab,
  Grid,
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import api from '../../api/api';

const CourierMaterialTypeListingPage = () => {

  const [courierMaterialTypes, setCourierMaterialTypes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openDialog, setOpenDialog] = useState(false);
  const [currentCourierMaterialType, setCurrentCourierMaterialType] = useState(null);
  const [name, setName] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [dialogType, setDialogType] = useState('add');

  useEffect(() => {
    fetchCourierMaterialTypes();
  }, []);

  const fetchCourierMaterialTypes = async () => {
    try {
      const response = await api.get('/api/CourierMaterialType');
      setCourierMaterialTypes(response.data);
    } catch (error) {
      console.error('Error fetching Courier Material Types', error);
    } finally {
      setLoading(false);
    }
  };

  const handleOpenDialog = (type, courierMaterialType = null) => {

    setDialogType(type);
    setCurrentCourierMaterialType(courierMaterialType);
    if (courierMaterialType) {
      setName(courierMaterialType.name);
    } else {
      setName('');
    }
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setCurrentCourierMaterialType(null);
    setName('');
  };

  const handleSaveCourierMaterialType = async () => {
    if (name.trim() === '') {
      return;
    }

    try {
      if (dialogType === 'add') {
        await api.post('/api/CourierMaterialType', { name });
      } else {
        const id = currentCourierMaterialType.id;
        await api.put(`/api/CourierMaterialType/${currentCourierMaterialType.id}`, { id, name });
      }
      fetchCourierMaterialTypes();
      handleCloseDialog();
    } catch (error) {
      console.error('Error saving Courier Material Type', error);
    }
  };

  const handleDeleteCourierMaterialType = async () => {
    try {
      await api.delete(`/api/CourierMaterialType/${currentCourierMaterialType.id}`);
      fetchCourierMaterialTypes();
      handleCloseDialog();
    } catch (error) {
      console.error('Error deleting Courier Material Type', error);
    }
  };

  const handleMenuOpen = (event, courierMaterialType) => {
    setCurrentCourierMaterialType(courierMaterialType);
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box  sx={{ p: 2 }}>
      <Typography marginBottom={2} component="p" variant="h5">Courier Material Types</Typography>
      {loading ? (
        <Typography>Loading...</Typography>
      ) : courierMaterialTypes.length === 0 ? (
        <Typography>No Material Type Added.</Typography>
      ) : (
        <Grid container spacing={2}>
          {courierMaterialTypes.map((courierMaterialType) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={courierMaterialType.id}>
              <Card>
                <CardContent>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Box>
                      <Typography variant="h6">{courierMaterialType.name}</Typography>
                    </Box>
                    <IconButton
                      aria-label="more"
                      aria-controls="long-menu"
                      aria-haspopup="true"
                      onClick={(event) => handleMenuOpen(event, courierMaterialType)}
                    >
                      <MoreVertIcon />
                    </IconButton>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}
      <Menu
        id="long-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
      >
        <MenuItem onClick={() => {
          handleOpenDialog('edit', currentCourierMaterialType);
          handleMenuClose();
        }}>Edit</MenuItem>
        <MenuItem onClick={() => {
          handleOpenDialog('delete', currentCourierMaterialType);
          handleMenuClose();
        }}>Delete</MenuItem>
      </Menu>
      <Fab color="primary" aria-label="add" sx={{ position: 'fixed', bottom: 16, right: 16 }} onClick={() => handleOpenDialog('add')}>
        <AddIcon />
      </Fab>
      {(dialogType === 'add' || dialogType === 'edit') && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>{dialogType === 'add' ? 'Add New Courier Material Type' : 'Edit Courier Material Type'}</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              label="Courier Material Type Name"
              type="text"
              fullWidth
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleSaveCourierMaterialType} variant="contained" color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>
      )}
      {dialogType === 'delete' && (
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>Confirm Delete</DialogTitle>
          <DialogContent>
            <Typography>Are you sure you want to delete this courierMaterialType?</Typography>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog}>Cancel</Button>
            <Button onClick={handleDeleteCourierMaterialType} variant="contained" color="secondary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      )}
    </Box>
  );
};

export default CourierMaterialTypeListingPage;
